



















































import { Component, Mixins, Prop, PropSync, VModel } from 'vue-property-decorator'

import FlowsTemplatesMixin from '../../FlowsTemplates/FlowsTemplatesMixin'
import { FlowTemplate } from '../../FlowsTemplates/types'
import { AddNewFlowAction, FlowItem, FlowsListConfig } from '../types'
import CommonAddFlowActions from './CommonAddFlowActions.vue'
import ImportFlowTemplate from './ImportFlowTemplate.vue'

@Component({
  data() {
    return {
      AddNewFlowAction,
    }
  },
  components: {
    CommonAddFlowActions,
    ImportFlowTemplate
  }
})
export default class FlowActionsModal extends Mixins(FlowsTemplatesMixin) {
  @VModel({ type: Boolean, default: false }) isAddFlowModalOpen!: boolean

  @PropSync('currentAction') actionType!: AddNewFlowAction

  @Prop() createFlow!: FlowsListConfig['createFlow']

  @Prop() importFlow!: FlowsListConfig['importFlow']

  @Prop() copyFlow!: FlowsListConfig['copyFlow']

  @Prop() flowTemplate!: FlowTemplate

  @Prop() onFlowMastersButtonClick!: FlowsListConfig['onFlowMastersButtonClick']

  @Prop() activeFlow!: FlowItem

  createFlowLoad = false

  get addFlowModalWidth() {
    if (this.actionType === AddNewFlowAction.ImportTemplate) {
      return this.modalWidth
    } else {
      return undefined
    }
  }

  get addFlowModalTitle() {
    return [ AddNewFlowAction.Create, AddNewFlowAction.Copy ].includes(this.actionType)
      ? this.$t('flows_list_add_new_flow').toString()
      : this.$t('flows_list_import_flow_title').toString()
  }

  closeModal() {
    this.isAddFlowModalOpen = false
  }
}
